"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=registration-config.dto.js.map